import { render, staticRenderFns } from "./RegistrosFotograficos.vue?vue&type=template&id=13413170&"
import script from "./RegistrosFotograficos.vue?vue&type=script&lang=js&"
export * from "./RegistrosFotograficos.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosFotograficos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports